import { render, staticRenderFns } from "./FinancialSettlementTips.vue?vue&type=template&id=cf31f444&"
import script from "./FinancialSettlementTips.vue?vue&type=script&lang=ts&"
export * from "./FinancialSettlementTips.vue?vue&type=script&lang=ts&"
import style0 from "./FinancialSettlementTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports